import React from "react";
import "./Home.css";
import faqimage from "../../assets/images/faqimage.png";
import FaqData from "../Faqdata";
import Accordion from "react-bootstrap/Accordion";

function Faq({ faqs = [] }) {
  const displayFaqs = faqs.length > 0 ? faqs.map((f, idx) => ({
    id: idx,
    title: f.hf_title,
    content: f.ht_description
  })) : FaqData;
  return (
    <div className="faq_sec">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4">
            <div className="section_heading ">
              <h4>
                Frequently Asked Questions
              </h4>
            </div>
            <div className="faq-image">
              <img src={faqimage} alt="Caregiver" className="img-fluid" />
            </div>
          </div>
          <div className="col-lg-8">
            <div className="faq-main">
              <Accordion defaultActiveKey="0">
                {displayFaqs.map((item) => (
                  <Accordion.Item eventKey={item.id.toString()} key={item.id}>
                    <Accordion.Header>{item.title}</Accordion.Header>
                    <Accordion.Body>{item.content}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Faq;
